import { useEffect, useState } from "react"
import { useShallow } from "zustand/react/shallow"
import { ResourceUploadField } from "~/components"
import { getVideoUrlDuration } from "~/common/media/uploadedResources"
import { RECREATE_VIDEO_RANGE } from "~/common/video/recreate"
import { useHotVideoStore } from "~/store/hotVideo"
import { SectionTitle } from "../SectionTitle"

export const ReferenceVideoField = ({
  className,
  onChange,
  allowClip = true,
}: {
  className?: string
  allowClip?: boolean
  onChange: (url: string) => void
}) => {
  const {
    videoUrl,
    videoDuration,
    start_time,
    end_time,
    draftRevision,
    setVideoDuration,
    setClipRange,
  } = useHotVideoStore(
    useShallow((state) => ({
      videoUrl: state.videoUrl,
      videoDuration: state.videoDuration,
      start_time: state.start_time,
      end_time: state.end_time,
      draftRevision: state.draftRevision,
      setClipRange: state.setClipRange,
      setVideoDuration: state.setVideoDuration,
    })),
  )
  const [loading, setLoading] = useState(false)
  const [failed, setFailed] = useState(false)
  const [attempt, setAttempt] = useState(0)
  useEffect(() => {
    let ignored = false
    setFailed(false)
    setLoading(Boolean(videoUrl))
    if (!videoUrl) return
    void getVideoUrlDuration(videoUrl)
      .then((duration) => {
        if (ignored) return
        if (!Number.isFinite(duration) || duration <= 0)
          throw new Error("无法读取有效的视频时长")
        setVideoDuration(duration)
      })
      .catch(() => {
        if (ignored) return
        setVideoDuration(undefined)
        setFailed(true)
      })
      .finally(() => {
        if (!ignored) setLoading(false)
      })
    return () => {
      ignored = true
    }
  }, [videoUrl, attempt, draftRevision, setVideoDuration])
  return (
    <ResourceUploadField
      label={
        <SectionTitle
          number={1}
          title="参考视频"
        />
      }
      required
      className={className}
      value={videoUrl}
      onChange={onChange}
      resourceType="video"
      enforceVideoDurationLimit={false}
      videoClip={
        allowClip
          ? {
              duration: videoDuration,
              durationStatus: loading ? "loading" : failed ? "error" : "idle",
              start_time,
              end_time,
              minDuration: RECREATE_VIDEO_RANGE.MIN,
              maxDuration: RECREATE_VIDEO_RANGE.MAX,
              onChange: setClipRange,
              onRetry: () => setAttempt((value) => value + 1),
            }
          : undefined
      }
    />
  )
}
